import '@/i18n';
import '@/index.css';
import 'python-format-js';

import React from 'react';
import ReactDOM from 'react-dom/client';

import EndService from '@/pages/EndService';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <EndService />
    </React.StrictMode>,
  );
}
